/* eslint-disable react/prop-types */
/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 10/08/2020.
 * @description Entry application component used to compose providers and render Module Component.
 * */

import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// Module Component
import ModulesComponent from "app/modules";

export default function App({ store, history, basename }) {
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
      {/* Override `basename` (e.g: `homepage` in `package.json`) */}
      <BrowserRouter basename={basename} history={history}>
          <ModulesComponent />
      </BrowserRouter>
    </Provider>
  );
}
